import { ZoomFilterViewModel } from './zoom-filter-view-model';
import { ZoomMetaData } from '../../../meta-data/zoom-meta-data';
import { ZoomOperatorViewModelProperty } from '../zoom-operator-view-model-property';
import { GuidZoomPropertyViewModel } from '../property-view-model/guid-zoom-property-view-model';
import { ZoomPropertyViewModelInterface } from '../property-view-model/zoom-property-view-model.interface';
import { StringZoomPropertyViewModel } from '../property-view-model/string-zoom-property-view-model';
import type { ModifiedSubscriberInterface } from '@nts/std/interfaces';

export class GuidZoomFilterViewModel extends ZoomFilterViewModel<string> {
  constructor(metadata: ZoomMetaData, private modifiedSubscriber: ModifiedSubscriberInterface) {
    super(metadata);
    this.operator = new ZoomOperatorViewModelProperty(ZoomOperatorViewModelProperty.operatorsForGuid, modifiedSubscriber);
    this.filterValue = new GuidZoomPropertyViewModel(metadata.guidMetaData, modifiedSubscriber);
    this.init();
  }

  get filterValues(): Array<ZoomPropertyViewModelInterface<string>> {
    return this.internalZoomPropertyViewModelValues;
  }

  private internalZoomPropertyViewModelValues: Array<ZoomPropertyViewModelInterface<string>> = [];

  setZoomPropertyViewModelValues(pvmToSet: Array<ZoomPropertyViewModelInterface<string>>) {
    if (this.internalZoomPropertyViewModelValues != pvmToSet) {
      this.internalZoomPropertyViewModelValues = pvmToSet;
      this.modifiedSubscriber.notifyModified();
    }
  }

  setZoomPropertyViewModelValuesFromEntities(entities: Array<string>) {
    this.setZoomPropertyViewModelValues(entities.map((e: string) => {
      const vm: ZoomPropertyViewModelInterface<string> = this.getEmptyFilter();
      vm.setValue(e);
      return vm;
    }));
  }

  getEmptyFilter(): StringZoomPropertyViewModel {
    return new StringZoomPropertyViewModel(this.metaData.stringMetaData, this.modifiedSubscriber);
  }
}
